import script from "./cau-hinh-clickhouse.vue?vue&type=script&setup=true&lang=js"
export * from "./cau-hinh-clickhouse.vue?vue&type=script&setup=true&lang=js"

import "./cau-hinh-clickhouse.vue?vue&type=style&index=0&id=059c731e&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059c731e"]])

export default __exports__